module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/gold-disabled-normal-50.fe6e46da.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/gold-disabled-normal-50.png
// module id = 3445
// module chunks = 11